var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useState } from 'react';
import t from 'prop-types';
import BotonMuestraColor from './boton-muestra-color';
import * as HERRAMIENTA from './constantes';
import { is_touch_device } from '../util';
var ON_PRESIONADO = is_touch_device() ? 'onTouchStart' : 'onClick';

function MuestraColor(props) {
  var _eventos;

  var _useState = useState(false),
      abierta = _useState[0],
      setAbierta = _useState[1];

  var herramientaId = props.herramientaId,
      grupo = props.grupo,
      valores = props.valores,
      valorSeleccionado = props.valorSeleccionado,
      onPresionado = props.onPresionado,
      onDesplegada = props.onDesplegada;

  function handleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setAbierta(!abierta);
  }

  function handlePresionado(id, grupo, valor) {
    setAbierta(false);
    onPresionado(herramientaId, grupo, valor);
  }

  function handleTransitionEnd(e) {
    if (abierta && onDesplegada) {
      onDesplegada(e);
    }
  }

  var id = 'herramienta' + herramientaId;
  var style = {
    backgroundColor: valorSeleccionado
  };
  var clases = 'muestraColor' + (abierta ? ' abierta' : '');
  var eventos = (_eventos = {}, _eventos[ON_PRESIONADO] = handleClick, _eventos);
  return React.createElement('div', _extends({
    id: id,
    className: clases,
    style: style
  }, eventos), React.createElement('div', {
    className: 'barraTerciaria',
    onTransitionEnd: handleTransitionEnd
  }, valores.map(function (valor) {
    return React.createElement(BotonMuestraColor, {
      key: id + valor,
      herramientaId: id + '-' + valor,
      grupo: grupo,
      valor: valor,
      presionado: valor === valorSeleccionado,
      onPresionado: handlePresionado
    });
  })));
}

MuestraColor.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identificador del boton, por defecto: 'LapizColor' */
  herramientaId: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton, por defecto: 'Pizarra' */
  grupo: t.string,

  /** array de colores */
  valores: t.arrayOf(t.string).isRequired,

  /** color seleccionado */
  valorSeleccionado: t.string,

  /** evento que se lanza al pulsar un color: (hrramientaId, grupo, valor) => {...} */
  onPresionado: t.func,

  /** evento que se lanza al terminar la animacion de mostrar la barra terciaria */
  onDesplegada: t.func
} : {};
MuestraColor.defaultProps = {
  grupo: HERRAMIENTA.GRUPO_PIZARRA
};
export default MuestraColor;